import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConditionIdsPipe } from './condition-ids.pipe';

@NgModule({
  declarations: [ConditionIdsPipe],
  imports: [CommonModule],
  exports: [ConditionIdsPipe],
})
export class ConditionIdsPipeModule {}
